import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Switch, Route } from 'react-router-dom';

import { setTabs } from 'modules/common/Tabs/actions';
import ReportsContainer from 'modules/security/containers/ReportsContainer';
import Header from 'modules/common/Header';
import { tabs } from './constants';
import Booking from '../Booking';

export const Manager: React.FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setTabs(tabs));
  }, []);

  return (
    <React.Fragment>
      <Header />
      <Switch>
        <Route path="/manager" exact component={Booking} />
        <Route path="/manager/reports" component={ReportsContainer} />
      </Switch>
    </React.Fragment>
  );
};
